const transition = {
  duration: {
    ms: {
      short: 0.2,
      long: 0.4,
    },
    s: {
      short: 200,
      long: 400,
    },
  },
  ease: {
    css: {
      default: 'cubic-bezier(0,0,0,0)',
    },
  },
};

export default transition;
